import { DateTime } from 'luxon';
import React from 'react';

import LoadingSpinner from '../../components/LoadingSpinner';
import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { Container, HarbourDialContainer, Time } from './HarbourDial.style';
import { HarbourDialModel } from './types';
import WindDirectionPanel from './WindDirectionPanel';
import WindSpeedPanel from './WindSpeedPanel';

const HarbourDial: React.FC<IWidgetBlockComponent<HarbourDialModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return <LoadingSpinner />;
    }

    const {
        isOutdated,
        obsTime,
        obsData,
        settings: { runwayAngle, showWindDirection, showWindSpeed },
    } = widgetModel;

    return (
        <Container>
            <Time outdated={isOutdated}>{<span>{obsTime ? DateTime.fromISO(obsTime.iso8601).toFormat('DD MMM, HH:mm z') : 'No timestamp'}</span>}</Time>
            <HarbourDialContainer>
                {showWindSpeed && <WindSpeedPanel data={obsData} runwayAngle={runwayAngle} />}
                {showWindDirection && <WindDirectionPanel data={obsData} runwayAngle={runwayAngle} />}
            </HarbourDialContainer>
        </Container>
    );
};

export default HarbourDial;
